export const vueVersion = (form) => {
    return require('@/../package.json').dependencies.vue.split('.')[0].replace('^', '')
}; 